import React from 'react';
import { MainCard, StepItem } from 'components/CapitalRevamp';
import styles from '../StatusInvestment.css';

function InvestmentStep() {
  return (
    <div className={styles['investment-step-wrapper']}>
      <MainCard
        border="green"
        title="Bagaimana proses selanjutnya setelah pengajuan di Backoffice?"
      >
        <div className={styles['step-wrapper']}>
          <StepItem
            color="green"
            number={1}
            title="Review"
            position="first"
            info="(±7 hari)"
          >
            Review dokumen keuangan dan legalitas oleh Santara
          </StepItem>
          <StepItem
            color="green"
            number={2}
            title="Kesepakatan"
            info="(±2 hari)"
          >
            Penyusunan kesepakatan share saham, pembagian deviden, dan mekanisme
            perubahan di anggaran dasar
          </StepItem>
          <StepItem color="green" number={3} title="Promosi">
            Penyusunan media promosi dan prospektus kepada publik/investor
          </StepItem>
          <StepItem color="green" number={4} title="Penawaran Saham">
            Pembukaan penawaran saham di Santara (max. 60 hari)
          </StepItem>
          <StepItem color="green" number={5} title="Penyerahan" position="last">
            Penyerahan dana ke perusahaan dan saham ke investor
          </StepItem>
        </div>
      </MainCard>
    </div>
  );
}

export default InvestmentStep;
